import { catalog } from '@nolens/i18n';

/** Páginas «App para Mac» e «Ligar a app de Mac» (ADR-G25). */
export const macText = catalog(
  {
    title: 'Mac app',
    hint: 'Record processes in any Mac app (Excel, SAP, Finder, System Settings…). Like the extension, it only records with your account connected, and the guide opens here when you finish.',
    download: 'Download the Mac app',
    notAvailable: 'The Mac app is not available to download yet.',
    requirements: 'macOS 14 Sonoma or later, Apple silicon or Intel.',
    testVersion: 'Test version',
    testVersionHint:
      'This version is not notarized by Apple yet, so macOS blocks it the first time you open it:',
    install1: 'Open the DMG and drag Nolens Guides to Applications.',
    install2: 'Open the app. macOS warns that it can’t verify it: close the warning.',
    install3:
      'Go to System Settings → Privacy & Security and click “Open Anyway” (you’ll need your password).',
    permissions:
      'The app then explains each permission it needs (Screen Recording, Accessibility and Input Monitoring) and why.',
    connection: 'Connection',
    linked: (version: string, seen: string) =>
      `Connected to this account. Version ${version}, last seen ${seen}.`,
    notLinked: 'Not connected to this account yet.',
    connect: 'Connect the Mac app',
    connectHint: 'Opens the Mac app, which asks you to sign in here.',
    openApp: 'Open the app',
    whenExtension:
      'Only recording in Chrome? The extension sees the page itself, so its steps are more precise on websites.',
    backToGuides: 'Back to guides',
    // Ligar (/mac/ligar)
    linkTitle: 'Connect the Mac app',
    linkAsk: (email: string) => `Connect Nolens Guides for Mac to ${email}?`,
    linkWarn: 'Only continue if you just clicked “Connect” in the Mac app.',
    linkConfirm: 'Connect',
    cancel: 'Cancel',
    linkDone: 'Done. You can go back to the Mac app.',
    linkInvalid: 'This link is not valid. Go back to the Mac app and click “Connect” again.',
    // Gravar e guiar no Mac
    recordWhere: 'Where do you want to record?',
    recordInChrome: 'In Chrome',
    recordInChromeHint: 'With the extension, in a browser tab.',
    recordOnMac: 'On the Mac',
    recordOnMacHint: 'In any app, with the Mac app.',
  },
  {
    'pt-PT': {
      title: 'App para Mac',
      hint: 'Grave processos em qualquer aplicação do Mac (Excel, SAP, Finder, Definições do Sistema…). Como a extensão, só grava com a conta ligada, e o guia abre aqui quando concluir.',
      download: 'Descarregar a app para Mac',
      notAvailable: 'A app para Mac ainda não está disponível para descarregar.',
      requirements: 'macOS 14 Sonoma ou mais recente, Apple silicon ou Intel.',
      testVersion: 'Versão de teste',
      testVersionHint:
        'Esta versão ainda não foi notarizada pela Apple, por isso o macOS bloqueia-a da primeira vez que a abre:',
      install1: 'Abra o DMG e arraste o Nolens Guides para Aplicações.',
      install2: 'Abra a app. O macOS avisa que não a consegue verificar: feche o aviso.',
      install3:
        'Vá a Definições do Sistema → Privacidade e Segurança e carregue em «Abrir mesmo assim» (pede a sua palavra-passe).',
      permissions:
        'A app explica depois cada permissão de que precisa (Gravação de Ecrã, Acessibilidade e Monitorização de Entrada) e porquê.',
      connection: 'Ligação',
      linked: (version, seen) =>
        `Ligada a esta conta. Versão ${version}, vista pela última vez ${seen}.`,
      notLinked: 'Ainda não está ligada a esta conta.',
      connect: 'Ligar a app de Mac',
      connectHint: 'Abre a app de Mac, que pede para entrar aqui.',
      openApp: 'Abrir a app',
      whenExtension:
        'Só grava no Chrome? A extensão vê a própria página, por isso os passos nos sites ficam mais precisos.',
      backToGuides: 'Voltar aos guias',
      linkTitle: 'Ligar a app de Mac',
      linkAsk: (email) => `Ligar o Nolens Guides para Mac a ${email}?`,
      linkWarn: 'Só continue se acabou de carregar em «Ligar» na app de Mac.',
      linkConfirm: 'Ligar',
      cancel: 'Cancelar',
      linkDone: 'Feito. Pode voltar à app de Mac.',
      linkInvalid: 'Esta ligação não é válida. Volte à app de Mac e carregue em «Ligar» outra vez.',
      recordWhere: 'Onde quer gravar?',
      recordInChrome: 'No Chrome',
      recordInChromeHint: 'Com a extensão, num separador do browser.',
      recordOnMac: 'No Mac',
      recordOnMacHint: 'Em qualquer aplicação, com a app de Mac.',
    },
  },
);
